var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderEnsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 100,
    viewBox: "0 0 158 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13:281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7019 56V52.62H87.7459V48.356H94.9479V45.158H87.7459V40.946H95.7019V37.566H84.1579V56H95.7019Z",
    fill: "url(#paint0_linear_13:281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.685 56V37.566H111.097V49.76L103.427 37.566H98.9546V56H102.543V42.922L110.915 56H114.685Z",
    fill: "url(#paint1_linear_13:281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.181 41.96C130.765 39.88 129.049 37.176 124.577 37.176C121.093 37.176 118.155 39.672 118.155 42.948C118.155 45.73 120.053 47.628 122.991 48.226L125.565 48.746C126.995 49.032 127.801 49.864 127.801 50.93C127.801 52.23 126.735 53.192 124.811 53.192C122.211 53.192 120.937 51.554 120.781 49.734L117.453 50.618C117.739 53.244 119.897 56.39 124.785 56.39C129.075 56.39 131.441 53.53 131.441 50.696C131.441 48.096 129.647 45.912 126.293 45.262L123.719 44.768C122.367 44.508 121.717 43.702 121.717 42.688C121.717 41.466 122.861 40.348 124.603 40.348C126.943 40.348 127.775 41.934 127.957 42.948L131.181 41.96Z",
    fill: "url(#paint2_linear_13:281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5025 41.4194C32.9768 42.4334 34.1509 44.4376 34.1509 44.4376L47.7232 22L34.477 31.2502C33.6877 31.7767 33.0401 32.4895 32.5914 33.3255C31.9881 34.5868 31.6676 35.9646 31.6522 37.3626C31.6369 38.7607 31.927 40.1452 32.5025 41.4194Z",
    fill: "url(#paint3_linear_13:281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1245 48.8077C27.2741 50.9539 27.8804 53.0435 28.903 54.9363C29.9256 56.8292 31.3408 58.4818 33.0539 59.7833L47.7054 70C47.7054 70 38.5386 56.7889 30.8066 43.643C30.0239 42.2541 29.4976 40.7356 29.2531 39.1602C29.1449 38.4468 29.1449 37.7212 29.2531 37.0078C29.0515 37.3814 28.6602 38.1463 28.6602 38.1463C27.8762 39.7453 27.3423 41.4551 27.0771 43.2161C26.9244 45.0776 26.9403 46.949 27.1245 48.8077Z",
    fill: "url(#paint4_linear_13:281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5034 50.5806C64.0291 49.5667 62.8551 47.5625 62.8551 47.5625L49.2827 70L62.5289 60.7558C63.3182 60.2292 63.9658 59.5165 64.4145 58.6804C65.0187 57.4184 65.3397 56.0395 65.3551 54.6404C65.3704 53.2412 65.0798 51.8556 64.5034 50.5806Z",
    fill: "url(#paint5_linear_13:281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8814 43.1923C69.7318 41.0461 69.1255 38.9566 68.1029 37.0637C67.0803 35.1708 65.665 33.5182 63.952 32.2167L49.3004 22C49.3004 22 58.4614 35.2111 66.1992 48.357C66.9799 49.7463 67.5042 51.2647 67.7468 52.8398C67.855 53.5532 67.855 54.2788 67.7468 54.9922C67.9484 54.6187 68.3397 53.8537 68.3397 53.8537C69.1237 52.2548 69.6577 50.5449 69.9229 48.7839C70.0775 46.9226 70.0636 45.0512 69.8814 43.1923Z",
    fill: "url(#paint6_linear_13:281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5914 33.3255C33.0401 32.4895 33.6877 31.7767 34.477 31.2502L47.7232 22L34.1508 44.4435C34.1508 44.4435 32.9649 42.4393 32.5025 41.4253C31.9261 40.1503 31.6355 38.7647 31.6508 37.3656C31.6662 35.9664 31.9872 34.5876 32.5914 33.3255ZM27.1245 48.8077C27.2741 50.9539 27.8804 53.0435 28.903 54.9363C29.9256 56.8292 31.3408 58.4818 33.0539 59.7833L47.7054 70C47.7054 70 38.5386 56.7889 30.8066 43.643C30.0239 42.2541 29.4976 40.7356 29.2531 39.1602C29.1449 38.4468 29.1449 37.7212 29.2531 37.0078C29.0515 37.3814 28.6602 38.1463 28.6602 38.1463C27.8762 39.7453 27.3423 41.4551 27.0771 43.2161C26.9244 45.0776 26.9403 46.949 27.1245 48.8077ZM64.4797 50.5865C64.0053 49.5726 62.8313 47.5684 62.8313 47.5684L49.2827 70L62.5289 60.7558C63.3182 60.2292 63.9658 59.5165 64.4145 58.6804C65.0187 57.4184 65.3397 56.0395 65.3551 54.6404C65.3704 53.2412 65.0798 51.8556 64.5034 50.5806L64.4797 50.5865ZM69.8577 43.1983C69.7081 41.052 69.1017 38.9625 68.0791 37.0696C67.0565 35.1767 65.6413 33.5242 63.9283 32.2226L49.3004 22C49.3004 22 58.4614 35.2111 66.1992 48.357C66.9799 49.7463 67.5042 51.2647 67.7468 52.8398C67.855 53.5532 67.855 54.2788 67.7468 54.9922C67.9484 54.6187 68.3397 53.8537 68.3397 53.8537C69.1237 52.2548 69.6577 50.5449 69.9229 48.7839C70.0775 46.9226 70.0636 45.0512 69.8814 43.1923L69.8577 43.1983Z",
    fill: "url(#paint7_linear_13:281)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13:281",
    x: 0.973328,
    y: 0,
    width: 156.468,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13:281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13:281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13:281",
    x1: 96.5577,
    y1: 75.6889,
    x2: 70.0114,
    y2: -26.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13:281",
    x1: 96.5577,
    y1: 75.6889,
    x2: 70.0114,
    y2: -26.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13:281",
    x1: 96.5577,
    y1: 75.6889,
    x2: 70.0114,
    y2: -26.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13:281",
    x1: 96.5577,
    y1: 75.6889,
    x2: 70.0114,
    y2: -26.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13:281",
    x1: 96.5577,
    y1: 75.6889,
    x2: 70.0114,
    y2: -26.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13:281",
    x1: 96.5577,
    y1: 75.6889,
    x2: 70.0114,
    y2: -26.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13:281",
    x1: 96.5577,
    y1: 75.6889,
    x2: 70.0114,
    y2: -26.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13:281",
    x1: 96.5577,
    y1: 75.6889,
    x2: 70.0114,
    y2: -26.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderEnsLogo);
export default __webpack_public_path__ + "static/media/HeaderENSLogo.46d0581d9e6df385fc47f2e2abb28e6e.svg";
export { ForwardRef as ReactComponent };